<script lang="ts">
	import type { CashReceiptResponse, PaymentData } from "@hitit/api";
	//UI
	//Image
	import closeBtn from "@hitit/hub/src/assets/Icons/closeBtn.png";
	//Utils
	import { t, store, api } from "@hitit/hub/src/stores";
	import { DefaultDone } from "@hitit/new_ui";

	export let emailReceiptModal = false;
	export let emailReceiptModalData: MergePaymentDatas;
	export let loadPayments: () => void;

	interface MergePaymentDatas extends PaymentData {
		cashReceiptResponse?: CashReceiptResponse;
	}

	let emailSend = false;
	let email = "";
	let emailError = false;

	function modalCloseHandler() {
		emailReceiptModal = false;
		document.body.style.overflow = "unset";
		document.body.style.touchAction = "unset";
	}

	async function sendHandler() {
		try {
			const emailReg =
				/^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i;
			if (!emailReg.test(email)) {
				emailError = true;
				return;
			}
			const lastItem = [
				...(emailReceiptModalData.paymentTransactionDTOs || []),
			].pop();
			await $api.requestEmailReceipt({
				emailAddress: email,
				paymentTransactionId: lastItem?.id || "",
			});
			emailSend = true;
			loadPayments();
		} catch (e) {
			console.log(e);
		}
	}
</script>

<div class="modal-background" t-id="EmailReceiptModal">
	{#if emailSend}
		<div class="step-two modal">
			<img
				class="modal-close"
				src={closeBtn}
				alt="close"
				on:click={modalCloseHandler}
			/>
			<span class="title"
				>{$t("hub.order.email_receipt.email_receipt_send_completed")}</span
			>
			<div class="animation-box">
				<DefaultDone color={"#000000"} circleBackground={"#e5e6ec"} />
			</div>
			<div class="contents-box">
				<span class="email-address">{$t("hub.profile.email")}</span>
				<span class="box-content">{email}</span>
			</div>
			<div class="issuance-btn btn" on:click={modalCloseHandler}>
				<span>{$t("global.ok")}</span>
			</div>
		</div>
	{:else}
		<div class="step-one modal">
			<img
				class="modal-close"
				src={closeBtn}
				alt="close"
				on:click={modalCloseHandler}
			/>
			<span class="title"
				>{$t("hub.order.email_receipt.email_receipt_send")}</span
			>

			<span class="email-address">{$t("hub.profile.email")}</span>
			<div class="input-box">
				<input bind:value={email} on:input={() => (emailError = false)} />
				<img src={closeBtn} on:click={() => (email = "")} alt="close" />
			</div>
			{#if emailError}
				<span class="input-error">{$t("sso.error.notCorrectEmailForm")}</span>
			{/if}
			<div class="send-btn btn" on:click={sendHandler}>
				<span>전송</span>
			</div>
		</div>
	{/if}
</div>

<style lang="scss">
	@import "../../../variables.scss";
	.modal-background {
		position: fixed;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		width: 100vw;
		height: 100vh;
		background: rgba(70, 71, 75, 0.7);
		z-index: 10;
	}

	.modal {
		position: absolute;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		margin: auto;
		background-color: white;
		border-radius: 5px;

		.modal-close {
			position: absolute;
			top: -40px;
			right: 0px;
			width: 30px;
			height: 30px;
			cursor: pointer;
		}
	}
	.step-one {
		width: 320px;
		height: fit-content;
		max-height: 285px;
		padding: 20px 15px;

		.title {
			@include appleAdjustTextForSize(20);
			font-weight: 400;
			color: #46474b;
			margin-bottom: 30px;
		}

		.input-box {
			display: flex;
			align-items: center;
			width: 300px;
			height: 32px;
			background-color: #f0f0f4;
			border-radius: 5px;
			margin-top: 10px;
			padding-right: 20px;
			input {
				all: unset;
				width: 100%;
				@include appleAdjustTextForSize(16);
				color: #46474b;
				padding: 0px 10px;
			}
			img {
				width: 15px;
				height: 15px;
				cursor: pointer;
			}
		}
		.input-error {
			@include appleAdjustTextForSize(14);
			color: red;
			margin-right: auto;
		}
	}
	.btn {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 100%;
		height: 32px;
		min-height: 32px;
		border-radius: 5px;
		background-color: #6591fa;
		margin-top: 20px;
		cursor: pointer;

		span {
			color: white;
		}
	}

	.contents-box {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		gap: 10px;
		width: 100%;
	}

	.email-address {
		@include appleAdjustTextForSize(16);
		color: #6d6f76;
		margin-right: auto;
	}

	.step-two {
		width: 320px;
		height: 280px;
		padding: 20px 15px;

		.title {
			@include appleAdjustTextForSize(20);
			font-weight: 400;
			color: #46474b;
			margin-bottom: 30px;
		}

		.animation-box {
			width: 83px;
			height: 79px;
			margin-bottom: 20px;
		}

		.box-title {
			@include appleAdjustTextForSize(16);
			color: #6d6f76;
		}
		.box-content {
			@include appleAdjustTextForSize(16);
			font-weight: 400;
			color: #46474b;
		}
	}
	@include DesktopSize {
		.modal {
			.modal-close {
				top: 0;
				right: -60px;
				width: 40px;
				height: 40px;
			}
		}
		.step-one {
			width: 340px;
			padding: 30px;

			.title {
				@include appleAdjustTextForSize(16, false);
			}

			.input-box {
				width: 330px;
				height: 40px;
				padding-right: 10px;
				input {
					@include appleAdjustTextForSize(16, false);
				}
			}
			.input-error {
				@include appleAdjustTextForSize(14, false);
			}
		}
		.btn {
			height: 40px;
			min-height: 40px;
		}

		.email-address {
			@include appleAdjustTextForSize(16, false);
		}
		.step-two {
			width: 350px;
			padding: 30px;
			.title {
				@include appleAdjustTextForSize(16, false);
			}
			.box-title {
				@include appleAdjustTextForSize(16, false);
			}
			.box-content {
				@include appleAdjustTextForSize(16, false);
			}
		}
	}
</style>
